import { Component, ElementRef, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { EdizioneObj } from '../../classes/edizione-obj';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { directus, Edizione, Iscrizione, Progetto } from '../../../../directus';
import { readItem, updateItem } from '@directus/sdk';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IscrizioneObj } from '../../classes/iscrizione-obj';
import { AutoFocus } from '../../directives/autofocus.directive';

@Component({
  selector: 'app-presenza',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule, AutoFocus],
  templateUrl: './presenza.component.html',
  styleUrl: './presenza.component.css'
})
export class PresenzaComponent extends BaseComponent implements OnInit {
  edizione: EdizioneObj | undefined;
  progetto: Progetto | undefined;
  iscritto: IscrizioneObj | undefined;

  faCheck: any;
  @Input() _insertId?: string;
  @ViewChild("input") input?: ElementRef;

  constructor(router: Router, private route: ActivatedRoute, public zone: NgZone) {
    super(router);

    this.faCheck = faCheck;
  }
  async ngOnInit(): Promise<void> {
    if (this.route.snapshot.paramMap.get('id')) {
      const _id = this.route.snapshot.paramMap.get('id');
      if (_id) {
        const __id = _id as unknown as number;
        await this.getEdizioneById(__id);
        if (this.edizione && this.edizione != undefined) {
          const _idEd = Number(this.edizione.id);
          await this.getProgettoById(this.edizione.progetto);
          if (this.progetto?.colore) {
            this._bgColor = this.getBackgroundAlpha(this.progetto?.colore);
          }
        }
      } else {
        console.log(' Edizione non trovata!');
      }
    }
  }

  /*ISCRITTO*/
  async getIscrizioneById(id: number) {
    return directus
      .request<IscrizioneObj>(readItem('iscrizioni', id));
  }

  /*PRESENZA*/
  async registra(value: any) {
    try {
      this.iscritto = undefined;

      var n = 0;
      let substr = this._insertId;
      if (this._insertId != undefined) {
        n = this._insertId.lastIndexOf('/');
        substr = this._insertId.substring(n + 1);
        //alert(substr);
      }
      if (this._insertId != undefined && n <=0 ) {
        n = this._insertId.lastIndexOf('-');
        substr = this._insertId.substring(n + 1);
        alert(substr);
      }
      let _id = Number(this._insertId);
      if (n > 0 && substr) {
        _id = Number(substr);
      }
      if (!_id) alert('inserimento non valido');
      //console.log(_id);
      const _sub: IscrizioneObj = await this.getIscrizioneById(_id);

      const result = await directus
        .request<Iscrizione>(updateItem('iscrizioni', _id, { presenza: 1 }));

      this.zone.run(async () => {
        this.iscritto = _sub;
      });
      this._insertId = '';
      //this.input?.nativeElement.focus();
    } catch (error) {
      console.log(error);
    }
  };
  /*
  PROGETTO
  */
  async getProgettoById(id: number) {
    try {
      this.progetto = await directus
        .request<Progetto>(readItem('progetti', id));
    } catch (error) {
      console.log(error);
    }
  }
  /*
  EDIZIONE
  */
  async getEdizioneById(id: number) {
    const _ed: Edizione = await directus
      .request<Edizione>(readItem('edizione', id));

    this.edizione = new EdizioneObj(_ed);
  }

}
